import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GamesPage.css';
import NavigationButtons from '../components/NavigationButtons';
import poko_jump from '../assets/poko_jump.png';

function GamesPage() {
	const navigate = useNavigate();

	const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	// Block for small screens
	if (isSmallScreen) {
		return (
			<div className="games-page page">
				<div className="white-wrapper container">
					<div className="page-title">
						<h1>🎮 Games</h1>
						<h5>Oops! Try on a bigger screen</h5>
					</div>
					<div className="speech-section">
						<div className="speech-bubble-left">
							<strong>Oops! 👀</strong>
							<p>This games need more space to play.</p>
							<p>Please try again on a computer with a bigger screen!</p>
							<p>We'll be ready when you are! 💻🎉</p>
						</div>
						<img src={poko_jump} alt="Buddy jumping" className="poko" />
					</div>
				</div>
				<NavigationButtons />
			</div>
		);
	}

	return (
		<div className="games-page page">
			<div className="white-wrapper container">
				<div className="page-title">
					<h1>🎮 Games</h1>
					<h5>Play and sign your way to success!</h5>
				</div>
				<div className="speech-section">
					<div className="speech-bubble-left">
						<strong>
							Let's Play and Learn!
						</strong>
						<p>
							Pick a game to test your sign language memory and reflexes! 🎮🌟
						</p>
						<p>
							✨ Each game focuses on a different type of sign — letters, numbers, or everyday words.
						</p>
						<p>
							🎯 Tap a game card to start your fun challenge!
						</p>
						<div className='games-wrapper'>
							<button onClick={() => navigate('/games/quiz')}>
								<h4>✏️ Fun Quiz</h4>
								<p>Test your skills by guessing sign</p>
								<strong>with letters</strong>
							</button>

							<button onClick={() => navigate('/games/shaft')}>
								<h4>🎯 Shaft Game</h4>
								<p>Jump to hit the right sign</p>
								<strong>with numbers</strong>
							</button>

							<button onClick={() => navigate('/games/match')}>
								<h4>🃏 Memory Match</h4>
								<p>Find matching pairs</p>
								<strong>with common everyday signs</strong>
							</button>
						</div>
					</div>
					<img src={poko_jump} alt="Buddy jumping" className="poko" />
				</div>
			</div>

			<NavigationButtons />
		</div>
	)
}

export default GamesPage;